export const tableLabels = [
  {
    name: 'Linha',
    content: 'line',
  },
  {
    name: 'Erro',
    content: 'error',
  },
  {
    name: 'Placa',
    content: 'plate',
  },
  {
    name: 'Item do serviço',
    content: 'service',
  },
  {
    name: 'Observações Gerais',
    content: 'observations',
  },
  {
    name: 'KM do Veiculo',
    content: 'km',
  },
];

export const ErrorArray = {
  itens: [
    {
      plate: 'ETQ3H59',
      service: '',
      observations: '',
      km: '40.000 KM',
      error: 'A placa deve ter 7 caracteres',
    },
    {
      plate: 'ETQ3H59',
      service: '',
      observations: '',
      km: '40.000 KM',
      error: 'Verifique Placa Digitada',
    },
    {
      plate: 'ETQ3H59',
      service: '',
      observations: '',
      km: '40.000 KM',
      error: 'Campo obrigatorio: Observações Gerais',
    },
    {
      plate: 'ETQ3H59',
      service: '',
      observations: '',
      km: '40.000 KM',
      error:
        '0 km informado para a Placa “XXXX” é invalido, ele deve ser maior que o atual',
    },
    {
      plate: 'ETQ3H59',
      service: '',
      observations: '',
      km: '40.000 KM',
      error:
        '0 km informado nao pode ser superior ao anterior (XXXXX) em 25.000 km',
    },
  ],
};
